import { useContext } from "react";
import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import ModalTemplateWithForm from "../../../components/modal/modalTemplateWithForm";
import Body from "./components/body";
import { Context } from "./provider";
import DivSpinner from "../../../components/divSpinner";

const schema = yup.object().shape({
    ftm_bank_sort_code: yup
        .string()
        .required('Bank sort code is required')
        .matches(/^\d{2}-\d{2}-\d{2}$/, 'Bank sort code must be in the format XX-XX-XX'),
    ftm_bank_account_number: yup
        .string()
        .required('Bank account number is required')
        .matches(/^\d{4}-\d{4}$/, 'Bank account number must be in the format XXXX-XXXX'),
    ftm_vehicle_number: yup
        .string()
        .required('Vehicle registration is required'),
        // .matches(/^[A-Z]{2}\d{2}\s[A-Z]{3}$/, 'Vehicle registration must be in the format AB12 XYZ'),
    ftm_contact_number: yup
        .string()
        .transform(value => value.replace(/\s+/g, '')) // Remove all spaces
        .required('Phone number is required')
        .matches(/^\+447\d{2}\d{3}\d{4}$/, 'Phone number must be in the format +44 7XX XXX XXXX'),
    ftm_next_of_kin_contact_number: yup
        .string()
        .transform(value => value.replace(/\s+/g, '')) // Remove all spaces
        .required('Phone number is required')
        .matches(/^\+447\d{2}\d{3}\d{4}$/, 'Next of kin phone number must be in the format +44 7XX XXX XXXX'),
});
const Html = ({ open, handleClose, isApproveProcess }) => {
    const context = useContext(Context);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control,
        setValue
    } = useForm({
        resolver: yupResolver(schema),
    });

    return (
        <ModalTemplateWithForm
            show={open}
            closeFun={handleClose}
            size={"lg"}
            fullscreen={false}
            centered={true}
            dialogClassName={"modal-1200w"}
            title={'Edit tradespersons for more details'}
            body={
                <>
                    {context.state.is_loading ? (
                        <div style={{ height: `${window.innerHeight - 387}px` }}>
                            <DivSpinner />
                        </div>
                    ) : (
                        <Body
                            register={register}
                            reset={reset}
                            errors={errors}
                            setValue={setValue}
                            handleClose={handleClose}
                            control = {control}
                            isApproveProcess={isApproveProcess}
                        />
                    )}
                </>
            }
            footer={null}
            onSubmit={handleSubmit((data) => context.callFtmUpdate(data))}
        />
    );
};

export default Html;